import React, { useState } from 'react';
import { FiDownload, FiUpload, FiPlus, FiDollarSign, FiTrendingUp, FiTrendingDown, FiTrash2 } from 'react-icons/fi';
import * as XLSX from 'xlsx';

const CapybaraFundManager = () => {
  const [transactions, setTransactions] = useState([]);
  const [formData, setFormData] = useState({
    type: 'thu',
    date: new Date().toISOString().split('T')[0],
    description: '',
    amount: ''
  });
  const [showForm, setShowForm] = useState(false);

  // Tính tổng thu, chi và số dư
  const totals = transactions.reduce((acc, t) => {
    if (t.type === 'thu') {
      acc.income += t.amount;
    } else {
      acc.expense += t.amount;
    }
    return acc;
  }, { income: 0, expense: 0 });

  const balance = totals.income - totals.expense;

  // Thêm giao dịch
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.description || !formData.amount) return;

    const newTransaction = {
      id: Date.now(),
      type: formData.type,
      date: formData.date,
      description: formData.description,
      amount: parseFloat(formData.amount)
    };

    setTransactions([newTransaction, ...transactions]);
    setFormData({
      type: 'thu',
      date: new Date().toISOString().split('T')[0],
      description: '',
      amount: ''
    });
    setShowForm(false);
  };

  // Xuất Excel
  const exportToExcel = () => {
    const data = transactions.map(t => ({
      'Loại': t.type === 'thu' ? 'Thu' : 'Chi',
      'Ngày': t.date,
      'Mô tả': t.description,
      'Số tiền': t.amount
    }));

    data.push({});
    data.push({ 'Loại': 'Tổng Thu', 'Số tiền': totals.income });
    data.push({ 'Loại': 'Tổng Chi', 'Số tiền': totals.expense });
    data.push({ 'Loại': 'Số dư', 'Số tiền': balance });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Quỹ Cầu Lông');
    XLSX.writeFile(wb, 'quy-cau-long-capybara.xlsx');
  };

  // Nhập Excel
  const importFromExcel = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const wb = XLSX.read(event.target.result, { type: 'binary' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws);

      const imported = data
        .filter(row => row['Loại'] && row['Mô tả'] && row['Số tiền'])
        .map((row, idx) => ({
          id: Date.now() + idx,
          type: row['Loại'].toLowerCase() === 'thu' ? 'thu' : 'chi',
          date: row['Ngày'] || new Date().toISOString().split('T')[0],
          description: row['Mô tả'],
          amount: parseFloat(row['Số tiền'])
        }));

      setTransactions([...imported, ...transactions]);
    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  };

  // Xóa giao dịch
  const deleteTransaction = (id) => {
    setTransactions(transactions.filter(t => t.id !== id));
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      {/* Floating Capybaras */}
      <div style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        fontSize: '60px',
        animation: 'float 3s ease-in-out infinite',
        zIndex: 0,
        opacity: 0.3
      }}>
        🦫
      </div>
      <div style={{
        position: 'fixed',
        bottom: '30px',
        left: '30px',
        fontSize: '50px',
        animation: 'float 4s ease-in-out infinite 1s',
        zIndex: 0,
        opacity: 0.3
      }}>
        🦫
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        @keyframes slideIn {
          from { transform: translateY(-20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes bounce {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        .card-hover {
          transition: all 0.3s ease;
        }
        .card-hover:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }
        .btn-capybara {
          transition: all 0.3s ease;
          border: none;
          font-weight: 600;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .btn-capybara:hover {
          transform: scale(1.05);
          box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        }
        .transaction-row {
          animation: slideIn 0.5s ease;
          transition: all 0.3s ease;
        }
        .transaction-row:hover {
          background: rgba(255,255,255,0.1) !important;
          transform: scale(1.02);
        }
        .form-input {
          width: 100%;
          padding: 10px 15px;
          border-radius: 10px;
          border: 2px solid #ddd;
          font-size: 14px;
          transition: all 0.3s ease;
        }
        .form-input:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
        .form-label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #333;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th {
          padding: 15px;
          text-align: left;
          border-bottom: 2px solid #667eea;
          color: #667eea;
          font-weight: 700;
        }
        td {
          padding: 15px;
          border-bottom: 1px solid #eee;
        }
      `}</style>

      <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px', animation: 'slideIn 0.8s ease' }}>
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: '700', 
            color: 'white',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            marginBottom: '10px'
          }}>
            🦫 Quỹ Cầu Lông Capybara 🏸
          </h1>
          <p style={{ fontSize: '1.2rem', color: 'white', opacity: 0.9 }}>
            Quản lý thu chi một cách thư giãn như capybara
          </p>
        </div>

        {/* Summary Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '30px' }}>
          <div className="card-hover" style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '20px',
            padding: '25px',
            color: 'white',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>Tổng Thu</div>
                <div style={{ fontSize: '2rem', fontWeight: '700' }}>
                  {totals.income.toLocaleString('vi-VN')}đ
                </div>
              </div>
              <FiTrendingUp size={50} style={{ opacity: 0.8 }} />
            </div>
          </div>

          <div className="card-hover" style={{
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            borderRadius: '20px',
            padding: '25px',
            color: 'white',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>Tổng Chi</div>
                <div style={{ fontSize: '2rem', fontWeight: '700' }}>
                  {totals.expense.toLocaleString('vi-VN')}đ
                </div>
              </div>
              <FiTrendingDown size={50} style={{ opacity: 0.8 }} />
            </div>
          </div>

          <div className="card-hover" style={{
            background: balance >= 0 
              ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
              : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            borderRadius: '20px',
            padding: '25px',
            color: 'white',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
            animation: 'bounce 2s ease infinite'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: '0.9rem', opacity: 0.9 }}>Số Dư</div>
                <div style={{ fontSize: '2rem', fontWeight: '700' }}>
                  {balance.toLocaleString('vi-VN')}đ
                </div>
              </div>
              <FiDollarSign size={50} style={{ opacity: 0.8 }} />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          background: 'rgba(255,255,255,0.95)',
          borderRadius: '20px',
          padding: '25px',
          boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
          animation: 'slideIn 1s ease',
          marginBottom: '30px'
        }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
            <button
              onClick={() => setShowForm(!showForm)}
              className="btn-capybara"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                padding: '12px 25px',
                borderRadius: '15px'
              }}
            >
              <FiPlus size={20} />
              Thêm Giao Dịch
            </button>

            <button
              onClick={exportToExcel}
              className="btn-capybara"
              style={{
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                color: 'white',
                padding: '12px 25px',
                borderRadius: '15px'
              }}
            >
              <FiDownload size={20} />
              Xuất Excel
            </button>

            <label className="btn-capybara" style={{
              background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
              color: 'white',
              padding: '12px 25px',
              borderRadius: '15px',
              margin: 0
            }}>
              <FiUpload size={20} />
              Nhập Excel
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={importFromExcel}
                style={{ display: 'none' }}
              />
            </label>
          </div>

          {/* Form */}
          {showForm && (
            <div style={{
              background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
              padding: '25px',
              borderRadius: '15px',
              marginTop: '20px',
              animation: 'slideIn 0.5s ease'
            }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                <div>
                  <label className="form-label">Loại</label>
                  <select
                    className="form-input"
                    value={formData.type}
                    onChange={(e) => setFormData({...formData, type: e.target.value})}
                  >
                    <option value="thu">Thu</option>
                    <option value="chi">Chi</option>
                  </select>
                </div>

                <div>
                  <label className="form-label">Ngày</label>
                  <input
                    type="date"
                    className="form-input"
                    value={formData.date}
                    onChange={(e) => setFormData({...formData, date: e.target.value})}
                  />
                </div>

                <div>
                  <label className="form-label">Mô tả</label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="VD: Phí sân tháng 10"
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                  />
                </div>

                <div>
                  <label className="form-label">Số tiền (VNĐ)</label>
                  <input
                    type="number"
                    className="form-input"
                    placeholder="100000"
                    value={formData.amount}
                    onChange={(e) => setFormData({...formData, amount: e.target.value})}
                  />
                </div>
              </div>

              <button
                onClick={handleSubmit}
                className="btn-capybara"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: '10px 30px',
                  borderRadius: '10px',
                  marginTop: '20px'
                }}
              >
                Lưu Giao Dịch
              </button>
            </div>
          )}
        </div>

        {/* Transactions Table */}
        <div style={{
          background: 'rgba(255,255,255,0.95)',
          borderRadius: '20px',
          padding: '25px',
          boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
          animation: 'slideIn 1.2s ease'
        }}>
          <h3 style={{ color: '#667eea', fontWeight: '700', marginBottom: '20px' }}>
            📊 Chi Tiết Giao Dịch
          </h3>

          {transactions.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <div style={{ fontSize: '80px' }}>🦫</div>
              <p style={{ fontSize: '1.2rem', color: '#666' }}>
                Chưa có giao dịch nào. Hãy thêm giao dịch đầu tiên!
              </p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table>
                <thead>
                  <tr>
                    <th>Loại</th>
                    <th>Ngày</th>
                    <th>Mô tả</th>
                    <th>Số tiền</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((t) => (
                    <tr key={t.id} className="transaction-row">
                      <td>
                        <span style={{
                          padding: '5px 15px',
                          borderRadius: '20px',
                          fontWeight: '600',
                          background: t.type === 'thu' 
                            ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
                            : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                          color: 'white',
                          display: 'inline-block'
                        }}>
                          {t.type === 'thu' ? '📈 Thu' : '📉 Chi'}
                        </span>
                      </td>
                      <td style={{ fontWeight: '500' }}>{t.date}</td>
                      <td>{t.description}</td>
                      <td style={{
                        fontWeight: '700',
                        color: t.type === 'thu' ? '#00f2fe' : '#f5576c'
                      }}>
                        {t.amount.toLocaleString('vi-VN')}đ
                      </td>
                      <td>
                        <button
                          onClick={() => deleteTransaction(t.id)}
                          className="btn-capybara"
                          style={{
                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            color: 'white',
                            borderRadius: '10px',
                            padding: '8px 15px',
                            fontSize: '14px'
                          }}
                        >
                          <FiTrash2 size={16} />
                          Xóa
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '30px', color: 'white', opacity: 0.8 }}>
          <p>🦫 Made with love by Capybara Team 🏸</p>
        </div>
      </div>
    </div>
  );
};

export default CapybaraFundManager;